/**
 * Application constants
 */

export const APP_NAME = 'Bolão 2026';
export const APP_DESCRIPTION = 'O maior bolão da Copa do Mundo 2026';

// Scoring rules
export const SCORING = {
  EXACT_SCORE: 10,
  CORRECT_DIFF: 7,
  CORRECT_WINNER: 3,
  WRONG: 0,
  CHAMPION: 25,
  TOP_SCORER: 20,
  FINALIST: 15,
  GROUP_WINNER: 10,
} as const;

// Match stages
export const STAGES = [
  { value: 'GROUP_A', label: 'Grupo A' },
  { value: 'GROUP_B', label: 'Grupo B' },
  { value: 'GROUP_C', label: 'Grupo C' },
  { value: 'GROUP_D', label: 'Grupo D' },
  { value: 'GROUP_E', label: 'Grupo E' },
  { value: 'GROUP_F', label: 'Grupo F' },
  { value: 'GROUP_G', label: 'Grupo G' },
  { value: 'GROUP_H', label: 'Grupo H' },
  { value: 'GROUP_I', label: 'Grupo I' },
  { value: 'GROUP_J', label: 'Grupo J' },
  { value: 'GROUP_K', label: 'Grupo K' },
  { value: 'GROUP_L', label: 'Grupo L' },
  { value: 'ROUND_32', label: 'Oitavas de Final' },
  { value: 'QUARTER', label: 'Quartas de Final' },
  { value: 'SEMI', label: 'Semifinal' },
  { value: 'THIRD_PLACE', label: 'Disputa pelo 3º lugar' },
  { value: 'FINAL', label: 'Final' },
] as const;

// Match statuses
export const MATCH_STATUSES = [
  { value: 'scheduled', label: 'Agendado' },
  { value: 'live', label: 'Ao Vivo' },
  { value: 'finished', label: 'Encerrado' },
  { value: 'postponed', label: 'Adiado' },
  { value: 'cancelled', label: 'Cancelado' },
] as const;

// World Cup 2026 Teams (48 teams)
export const TEAMS = [
  // Host nations
  { name: 'Estados Unidos', code: 'USA', flag: '🇺🇸' },
  { name: 'Mexico', code: 'MEX', flag: '🇲🇽' },
  { name: 'Canada', code: 'CAN', flag: '🇨🇦' },
  // South America
  { name: 'Brasil', code: 'BRA', flag: '🇧🇷' },
  { name: 'Argentina', code: 'ARG', flag: '🇦🇷' },
  { name: 'Uruguai', code: 'URU', flag: '🇺🇾' },
  { name: 'Colombia', code: 'COL', flag: '🇨🇴' },
  { name: 'Equador', code: 'ECU', flag: '🇪🇨' },
  { name: 'Chile', code: 'CHI', flag: '🇨🇱' },
  { name: 'Paraguai', code: 'PAR', flag: '🇵🇾' },
  // Europe
  { name: 'Franca', code: 'FRA', flag: '🇫🇷' },
  { name: 'Inglaterra', code: 'ENG', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
  { name: 'Espanha', code: 'ESP', flag: '🇪🇸' },
  { name: 'Alemanha', code: 'GER', flag: '🇩🇪' },
  { name: 'Portugal', code: 'POR', flag: '🇵🇹' },
  { name: 'Holanda', code: 'NED', flag: '🇳🇱' },
  { name: 'Belgica', code: 'BEL', flag: '🇧🇪' },
  { name: 'Italia', code: 'ITA', flag: '🇮🇹' },
  { name: 'Croacia', code: 'CRO', flag: '🇭🇷' },
  { name: 'Suica', code: 'SUI', flag: '🇨🇭' },
  { name: 'Dinamarca', code: 'DEN', flag: '🇩🇰' },
  { name: 'Polonia', code: 'POL', flag: '🇵🇱' },
  { name: 'Austria', code: 'AUT', flag: '🇦🇹' },
  { name: 'Ucrania', code: 'UKR', flag: '🇺🇦' },
  { name: 'Servia', code: 'SRB', flag: '🇷🇸' },
  { name: 'Suecia', code: 'SWE', flag: '🇸🇪' },
  { name: 'Turquia', code: 'TUR', flag: '🇹🇷' },
  // Africa
  { name: 'Marrocos', code: 'MAR', flag: '🇲🇦' },
  { name: 'Senegal', code: 'SEN', flag: '🇸🇳' },
  { name: 'Nigeria', code: 'NGA', flag: '🇳🇬' },
  { name: 'Camaroes', code: 'CMR', flag: '🇨🇲' },
  { name: 'Gana', code: 'GHA', flag: '🇬🇭' },
  { name: 'Costa do Marfim', code: 'CIV', flag: '🇨🇮' },
  // Asia
  { name: 'Japao', code: 'JPN', flag: '🇯🇵' },
  { name: 'Coreia do Sul', code: 'KOR', flag: '🇰🇷' },
  { name: 'Australia', code: 'AUS', flag: '🇦🇺' },
  { name: 'Ira', code: 'IRN', flag: '🇮🇷' },
  { name: 'Arabia Saudita', code: 'KSA', flag: '🇸🇦' },
  { name: 'Qatar', code: 'QAT', flag: '🇶🇦' },
  // CONCACAF
  { name: 'Costa Rica', code: 'CRC', flag: '🇨🇷' },
  { name: 'Jamaica', code: 'JAM', flag: '🇯🇲' },
  { name: 'Honduras', code: 'HON', flag: '🇭🇳' },
  // Oceania
  { name: 'Nova Zelandia', code: 'NZL', flag: '🇳🇿' },
] as const;

// Get team by name
export function getTeamByName(name: string) {
  return TEAMS.find(t =>
    t.name.toLowerCase() === name.toLowerCase() ||
    t.code.toLowerCase() === name.toLowerCase()
  );
}

// Navigation routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/entrar',
  REGISTER: '/cadastro',
  FORGOT_PASSWORD: '/recuperar-senha',
  RESET_PASSWORD: '/resetar-senha',
  DASHBOARD: '/inicio',
  MATCHES: '/jogos',
  MATCH_DETAIL: '/jogos/:id',
  POOLS: '/boloes',
  POOL_CREATE: '/boloes/criar',
  POOL_DETAIL: '/boloes/:slug',
  POOL_RANKING: '/boloes/:slug/ranking',
  POOL_RULES: '/boloes/:slug/regras',
  POOL_PREDICTIONS: '/boloes/:slug/palpites',
  POOL_SPECIALS: '/boloes/:slug/especiais',
  PROFILE: '/perfil',
  ADMIN: '/admin',
} as const;

// Brazil theme colors
export const THEME = {
  primary: '#009739',
  secondary: '#FEDD00',
  accent: '#002776',
  background: '#ffffff',
  surface: '#f5f5f5',
  text: '#1a1a1a',
  textMuted: '#6b7280',
} as const;
